import { Editor } from "@tiptap/react";

import GuidedHighlightingIcon from "@/icons/GuidedHighlightingIcon";
import useGuidedHighlightingStudentAnswer from "@/view/utils/useGuidedHighlightingStudentAnswer";
import BaseTextSelectionMenu from "../BaseTextSelectionMenu";
import { getGuidedHighlightingOnClick } from "./utils";

interface GuidedHighlightingTextSelectionMenuProps {
  editor: Editor;
}

const GuidedHighlightingTextSelectionMenu = ({
  editor,
}: GuidedHighlightingTextSelectionMenuProps) => {
  const state = editor.state;

  const { handleHighlightingText } = useGuidedHighlightingStudentAnswer();

  const title = "Select Text";
  const onClick = getGuidedHighlightingOnClick(state, handleHighlightingText);
  /* @ts-ignore: AnnotateIcon is not typed */
  const icon = <GuidedHighlightingIcon />;

  return (
    <BaseTextSelectionMenu
      editor={editor}
      title={title}
      onClick={onClick}
      icon={icon}
      dataTestId="GuidedHighlightingTextSelectionMenu"
    />
  );
};

export default GuidedHighlightingTextSelectionMenu;
